import { Component, OnInit } from '@angular/core';
/* Imports */
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { Proceso, Mes } from 'src/app/classes/coordinador';
import { ApiProcesosService } from 'src/app/shared/services/api-procesos.service';
import { ApiEstadisticasService } from 'src/app/shared/services/api-estadisticas.service';

@Component({
  selector: 'app-metricas-globales',
  templateUrl: './metricas-globales.component.html',
  styleUrls: ['./metricas-globales.component.css']
})
export class MetricasGlobalesComponent implements OnInit {
  // Loading
  loadingProcesos;
  loading10Peores;
  loadingCumplimientoEmpresas;
  loadingAtrasosEmpresas;

  // Filtros
  filtros: {
    procesos: Proceso[];
    annos: number[];
    meses: Mes[];
  };

  filtrosSeleccionados: {
    proceso: Proceso;
    anno: number;
    mes: Mes;
  };

  procesoFiltro: any;

  // Data
  diezPeores;
  cumplimientoEmpresas;
  atrasosEmpresas;

  // Mensajeria
  error10Peores;
  errorCumplimientoEmpresas;
  errorAtrasosEmpresas;

  constructor(
    private apiProcesoService: ApiProcesosService,
    private apiEstadisticasService: ApiEstadisticasService
  ) {}

  ngOnInit() {
    this.inicializarFiltros();
    this.cargarProcesos();
    this.cargarAnnos();
    this.cargarMeses();

    am4core.useTheme(am4themes_animated);
  }

  inicializarFiltros() {
    this.filtros = {
      procesos: [],
      annos: [],
      meses: []
    };
    this.filtrosSeleccionados = {
      proceso: undefined,
      anno: undefined,
      mes: undefined
    };
    this.filtrosSeleccionados.anno = new Date(
      new Date().getFullYear(),
      new Date().getMonth() - 1,
      1
    ).getFullYear();
  }

  cargarProcesos() {
    this.loadingProcesos = true;
    this.apiProcesoService
      .getProcesos()
      .then((procesos: any) => {
        this.filtros.procesos = procesos;
        this.loadingProcesos = false;
      })
      .catch(() => {
        this.loadingProcesos = false;
      });
  }

  todosLosFiltrosSeleccionados() {
    return this.filtrosSeleccionados.proceso && this.filtrosSeleccionados.anno;
  }

  cargarGraficos() {
    if (this.todosLosFiltrosSeleccionados()) {
      this.cargar10Peores();
      this.cargarCumplimientoEmpresas();
      this.cargarAtrasosEmpresas();
    }
  }

  cargar10Peores() {
    this.loading10Peores = true;
    this.error10Peores = undefined;
    this.apiEstadisticasService
      .diezPeores(
        this.filtrosSeleccionados.proceso,
        this.filtrosSeleccionados.anno,
        this.filtrosSeleccionados.mes
      )
      .then(res => {
        this.diezPeores = res;
        this.loading10Peores = false;

        setTimeout(() => {
          if (this.diezPeores && this.diezPeores.length > 0) {
            this.crearGrafico10Peores();
          } else {
            this.error10Peores =
              'No existen datos para esta métrica con los filtros seleccionados.';
          }
        }, 100);
      })
      .catch(error => {
        this.loading10Peores = false;
      });
  }

  crearGrafico10Peores() {
    /* Chart code */
    // Create chart instance
    const chart = am4core.create('10Peores', am4charts.XYChart);

    // Add data

    const data = [];
    for (const peorEmpresa of this.diezPeores) {
      data.push({ Empresa: peorEmpresa.empresa, dias: peorEmpresa.dias });
    }
    chart.data = data;

    // Create axes
    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'Empresa';
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.labels.template.horizontalCenter = 'right';
    categoryAxis.renderer.labels.template.verticalCenter = 'middle';
    categoryAxis.renderer.labels.template.rotation = 310;
    categoryAxis.renderer.minGridDistance = 30;

    categoryAxis.renderer.labels.template.adapter.add(
      'dy',
      (dy, target: any) => {
        if (target.dataItem && target.dataItem.index) {
          return dy + 25;
        }
        return dy;
      }
    );

    categoryAxis.title.text = 'Empresas';
    categoryAxis.title.fontWeight = '600';

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = 'Días de atraso';
    valueAxis.title.fontWeight = '600';

    // Create series
    const series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = 'dias';
    series.dataFields.categoryX = 'Empresa';
    series.name = 'Visits';
    series.columns.template.tooltipText = '{categoryX}: [bold]{valueY}[/]';
    series.columns.template.fillOpacity = 0.8;

    const columnTemplate = series.columns.template;
    columnTemplate.strokeWidth = 2;
    columnTemplate.strokeOpacity = 1;

    // Export
    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.filePrefix =
      '10_Peores_' +
      this.filtrosSeleccionados.proceso.sigla +
      this.filtrosSeleccionados.anno;
  }

  cargarCumplimientoEmpresas() {
    this.loadingCumplimientoEmpresas = true;
    this.errorCumplimientoEmpresas = undefined;

    this.apiEstadisticasService
      .cumplimiento(
        this.filtrosSeleccionados.proceso,
        this.filtrosSeleccionados.anno,
        this.filtrosSeleccionados.mes
      )
      .then(res => {
        this.cumplimientoEmpresas = res;
        this.loadingCumplimientoEmpresas = false;

        setTimeout(() => {
          if (
            this.cumplimientoEmpresas &&
            this.cumplimientoEmpresas.length > 0
          ) {
            this.crearGraficoCumplimientoEmpresas();
          } else {
            this.errorCumplimientoEmpresas =
              'No existen datos para esta métrica con los filtros seleccionados.';
          }
        }, 100);
      })
      .catch(error => {
        this.loadingCumplimientoEmpresas = false;
      });
  }

  crearGraficoCumplimientoEmpresas() {
    // Create chart instance
    const chart = am4core.create('cumplimientoEmpresas', am4charts.PieChart);

    chart.data = [];
    let colorList = [];

    // Add data
    for (const cumplimiento of this.cumplimientoEmpresas) {
      if (cumplimiento.cumplimiento === 'FALSE') {
        chart.data.push({
          estado: 'No Cumple',
          empresas: cumplimiento.empresas,
          color: am4core.color('#C0392B')
        });
      } else {
        chart.data.push({
          estado: 'Cumple',
          empresas: cumplimiento.empresas,
          color: am4core.color('#2E86C1')
        });
      }
    }

    if (chart.data.length === 1) {
      if (chart.data[0].estado === 'No Cumple') {
        colorList.push(am4core.color('#C0392B'));
      } else {
        colorList.push(am4core.color('#2E86C1'));
      }
    } else {
      colorList = [chart.data[0].color, chart.data[1].color];
    }

    // Add and configure Series
    const pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = 'empresas';
    pieSeries.dataFields.category = 'estado';
    pieSeries.slices.template.stroke = am4core.color('#fff');
    pieSeries.slices.template.strokeWidth = 2;
    pieSeries.slices.template.strokeOpacity = 1;

    // This creates initial animation
    pieSeries.hiddenState.properties.opacity = 1;
    pieSeries.hiddenState.properties.endAngle = -90;
    pieSeries.hiddenState.properties.startAngle = -90;

    // Color
    pieSeries.colors.list = colorList;

    // Export
    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.filePrefix =
    'Cumplimiento_Empresas_' +
    this.filtrosSeleccionados.proceso.sigla +
    this.filtrosSeleccionados.anno;
  }

  cargarAtrasosEmpresas() {
    this.loadingAtrasosEmpresas = true;
    this.errorAtrasosEmpresas = undefined;

    this.apiEstadisticasService
      .atraso(
        this.filtrosSeleccionados.proceso,
        this.filtrosSeleccionados.anno,
        this.filtrosSeleccionados.mes
      )
      .then(res => {
        this.atrasosEmpresas = res;
        this.loadingAtrasosEmpresas = false;

        setTimeout(() => {
          if (this.atrasosEmpresas && this.atrasosEmpresas.length > 0) {
            this.crearGraficoAtrasosEmpresas();
          } else {
            this.errorAtrasosEmpresas =
              'No existen datos para esta métrica con los filtros seleccionados.';
          }
        }, 100);
      })
      .catch(error => {
        this.loading10Peores = false;
      });
  }

  crearGraficoAtrasosEmpresas() {
    /* Chart code */
    // Create chart instance
    const chart = am4core.create('atrasosEmpresas', am4charts.XYChart);

    chart.data = [];
    // Add data
    for (let i = 0; i < 5; i++) {
      chart.data.push({
        empresas: 0,
        dias: i + ''
      });
    }

    chart.data.push({
      empresas: 0,
      dias: '+5'
    });

    for (const atraso of this.atrasosEmpresas) {
      chart.data[parseInt(atraso.dias, 0)].empresas = parseInt(
        atraso.empresas,
        0
      );
    }

    // Create axes
    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'dias';
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 30;

    categoryAxis.renderer.labels.template.horizontalCenter = 'right';
    categoryAxis.renderer.labels.template.verticalCenter = 'middle';
    // categoryAxis.renderer.labels.template.rotation = 270;
    categoryAxis.renderer.labels.template.rotation = 310;
    categoryAxis.tooltip.disabled = true;
    categoryAxis.renderer.minHeight = 110;

    categoryAxis.renderer.labels.template.adapter.add(
      'dy',
      (dy, target: any) => {
        if (target.dataItem && target.dataItem.index) {
          return dy + 25;
        }
        return dy;
      }
    );

    categoryAxis.title.text = 'Días de atraso';
    categoryAxis.title.fontWeight = '600';

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = 'Empresas';
    valueAxis.title.fontWeight = '600';

    // Create series
    const series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = 'empresas';
    series.dataFields.categoryX = 'dias';
    series.name = 'Visits';
    series.columns.template.tooltipText =
      '[bold]Días:[/] {categoryX}, [bold]Empresas:[/] {valueY}[/]';
    series.columns.template.fillOpacity = 0.8;
    series.tooltip.pointerOrientation = 'vertical';

    const columnTemplate = series.columns.template;
    columnTemplate.strokeWidth = 2;
    columnTemplate.strokeOpacity = 1;

    // Export
    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.filePrefix =
      'NEmpresas_DiasAtraso_' +
      this.filtrosSeleccionados.proceso.sigla +
      this.filtrosSeleccionados.anno;
  }

  cargarAnnos() {
    const primerAnno = new Date(
      new Date().getFullYear(),
      new Date().getMonth() + -1,
      1
    ).getFullYear();

    for (let i = primerAnno; i > primerAnno - 10 && i >= 2018; i--) {
      this.filtros.annos.push(i);
    }
  }

  cargarMeses() {
    this.filtrosSeleccionados.mes = undefined;

    this.filtros.meses = [
      {
        nombre: 'Enero',
        sigla: 'Ene',
        numero: 1,
        bloqueado: false
      },
      {
        nombre: 'Febrero',
        sigla: 'Feb',
        numero: 2,
        bloqueado: false
      },
      {
        nombre: 'Marzo',
        sigla: 'Mar',
        numero: 3,
        bloqueado: false
      },
      {
        nombre: 'Abril',
        sigla: 'Abr',
        numero: 4,
        bloqueado: false
      },
      {
        nombre: 'Mayo',
        sigla: 'May',
        numero: 5,
        bloqueado: false
      },
      {
        nombre: 'Junio',
        sigla: 'Jun',
        numero: 6,
        bloqueado: false
      },
      {
        nombre: 'Julio',
        sigla: 'Jul',
        numero: 7,
        bloqueado: false
      },
      {
        nombre: 'Agosto',
        sigla: 'Ago',
        numero: 8,
        bloqueado: false
      },
      {
        nombre: 'Septiembre',
        sigla: 'Sep',
        numero: 9,
        bloqueado: false
      },
      {
        nombre: 'Octubre',
        sigla: 'Oct',
        numero: 10,
        bloqueado: false
      },
      {
        nombre: 'Noviembre',
        sigla: 'Nov',
        numero: 11,
        bloqueado: false
      },
      {
        nombre: 'Diciembre',
        sigla: 'Dic',
        numero: 12,
        bloqueado: false
      }
    ];

    if (new Date().getFullYear() === this.filtrosSeleccionados.anno) {
      const mesActual = new Date().getMonth() + 1;
      for (const mes of this.filtros.meses) {
        mes.bloqueado = mes.numero >= mesActual;
      }
    }
  }
}
